import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { getPetitionQRCode } from '#src/app/shared/api/qrcode';
import { useAsyncDownload } from '#src/app/shared/hooks/download';

export const QRCodeDownloadLink: React.FC<
	PropsWithChildren<{
		slugOrId: string;
		type: QrCodeType;
		size?: number;
		filename?: string;
		/**
		 * @deprecated Use onClick instead.
		 */
		onDownload?: () => Promise<void>;
		onClick?: () => Promise<void>;
	}>
> = ({ children, slugOrId, size, type, filename, onClick, onDownload }) => {
	const utilityContext = useUtilityContext();

	const { actions } = useAsyncDownload({
		fetchData: async () => {
			const result = await getPetitionQRCode({
				slugOrId,
				type,
				size,
				utilityContext,
			});
			return { dataUri: result.imageBase64Uri };
		},
		filename: filename || 'petition-qrcode.png',
		onDownload: onClick || onDownload,
	});

	return (
		<Button
			onClick={actions.handleDownload}
			variant="secondary"
			size="small"
			data-qa="qrcode-download-link"
			data-testid="qrcode-download-link"
		>
			<Text variant="body" size="medium" fontWeight="bold">
				{children}
			</Text>
		</Button>
	);
};
